'use client';

import {
  LayoutGrid,
  TypographyRhythm,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

const Content = (): JSX.Element => {
  const t = useTranslations();
  return (
    <article>
      <LayoutGrid data-cy="page-guidelines-for-commercial-use-grid">
        <TypographyRhythm className="col-main">
          <TypographyV3 Element="h1" variant="h1" className="mb-16">
            {t('guidelines_for_commercial_use_title')}
          </TypographyV3>

          <TypographyV3 className="mb-24">
            {t.rich('guidelines_for_commercial_use_content')}
          </TypographyV3>
        </TypographyRhythm>
      </LayoutGrid>
    </article>
  );
};

export default Content;
